import React from 'react';
import { FileTextIcon, TrendingDownIcon, CalendarClockIcon, ShieldCheckIcon, SettingsIcon, RefreshCwIcon } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function ProductIntro() {
  const deliverables = [{
    icon: <FileTextIcon className="w-8 h-8" data-id="element-210" />,
    title: 'Un presupuesto de 1 página',
    desc: 'Que sí vas a usar y se adapta a ti.'
  }, {
    icon: <TrendingDownIcon className="w-8 h-8" data-id="element-211" />,
    title: 'Un plan de deuda',
    desc: '(Paso a paso) para avanzar más rápido.'
  }, {
    icon: <CalendarClockIcon className="w-8 h-8" data-id="element-212" />,
    title: 'Sistema de pagos',
    desc: 'Y fechas para dejar de pagar tarde.'
  }, {
    icon: <ShieldCheckIcon className="w-8 h-8" data-id="element-213" />,
    title: 'Fondo de emergencia',
    desc: 'Aunque empieces con poco.'
  }, {
    icon: <SettingsIcon className="w-8 h-8" data-id="element-214" />,
    title: 'Automatizaciones',
    desc: 'Para que el ahorro ocurra sin fuerza de voluntad.'
  }, {
    icon: <RefreshCwIcon className="w-8 h-8" data-id="element-215" />,
    title: 'Método mensual',
    desc: 'Para mantenerlo para siempre.'
  }];
  return <section className="py-24 bg-navy-800 relative overflow-hidden" data-id="element-216">
      {/* Decorative elements */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-gold-500/5 rounded-full blur-[80px]" data-id="element-217" />
      <div className="absolute bottom-0 left-0 w-64 h-64 bg-teal-900/30 rounded-full blur-[80px]" data-id="element-218" />

      <div className="container mx-auto px-4 max-w-6xl relative z-10" data-id="element-219">
        <FadeIn data-id="element-220">
          <div className="text-center mb-16" data-id="element-221">
            <h2 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-222">
              Te presento:{' '}
              <span className="text-gold-500" data-id="element-223">Finanzas Sin Excusas</span>
            </h2>
            <p className="text-xl text-slate-300 max-w-3xl mx-auto leading-relaxed mb-4" data-id="element-224">
              Un eBook profundo, directo y práctico que te guía por un plan de
              60 días para pasar de caos a control.
            </p>
            <p className="text-lg text-white font-medium inline-block px-4 py-2 bg-white/5 rounded-full border border-white/10" data-id="element-225">
              No es un libro "bonito" para inspirarte. Es un manual de acción.
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-226">
          <h3 className="text-2xl font-bold text-center mb-10" data-id="element-227">
            En 60 días vas a construir:
          </h3>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-228">
          {deliverables.map((item, index) => <FadeIn key={index} delay={0.3 + index * 0.1} data-id="element-229">
              <div className="glass-card h-full flex flex-col items-center text-center group" data-id="element-230">
                <div className="mb-6 p-4 rounded-2xl bg-gradient-to-br from-navy-900 to-teal-900 border border-white/5 text-gold-500 group-hover:scale-110 transition-transform duration-300 shadow-lg" data-id="element-231">
                  {item.icon}
                </div>
                <h4 className="text-xl font-bold text-white mb-3" data-id="element-232">
                  {item.title}
                </h4>
                <p className="text-slate-400" data-id="element-233">{item.desc}</p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}